import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import Text from '../Text';
import {useState} from 'react';
import {ValidatorForm} from 'react-material-ui-form-validator';
import {api} from '../../maps/data.js';
import Divider from '@mui/material/Divider';
import UploadProfileImageBox from "../uploadProfileImage/UploadProfileImageBox";

const ShopperAddDialog = ({open, onClose, shopper, onNewShopper}) => {
    const [email, setEmail] = useState(shopper ? shopper.email : '');
    const [imageBase64, setImageBase64] = useState(null);
    const [name, setName] = useState(shopper ? shopper.name : '');
    const [phone, setPhone] = useState(shopper ? shopper.phone : '');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [deleteImage, setDeleteImage] = useState(false);

    let imageToShow = "";
    if (imageBase64) {
        imageToShow = imageBase64;
    } else if (shopper && shopper.imageUrl) {
        imageToShow = shopper.imageUrl;
    }
    if (deleteImage) {
        imageToShow = "";
    }

    // if we are in EDIT mode, we don't need password, but if there is a password, we want to validate even if in EDIT mode
    let passwordValidation = ['required'];
    if (shopper) {
        passwordValidation = [];
        if (password || confirmPassword) {
            passwordValidation = ['required'];
        }
    }

    const save = async () => {
        let response = null;
        if (shopper) {
            response = await api({
                type: 'editShopper',
                data: {
                    email,
                    name,
                    password,
                    confirm_password: confirmPassword,
                    phone,
                    imageBase64,
                    id: shopper._id,
                    deleteImage
                }
            });
            onNewShopper && onNewShopper(response, true);
        } else {
            response = await api({
                type: 'addShopper',
                data: {
                    email, name, password, confirm_password: confirmPassword, phone, imageBase64
                }
            });
            onNewShopper && onNewShopper(response, false);
        }
        onClose && onClose();
    };

    const removeImageHandle = () => {
        setDeleteImage(true);
        setImageBase64(null);
    };

    const onImageSelect = (image) => {
        setImageBase64(image);
        setDeleteImage(false);
    };

    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >

            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    {shopper ? <Tx>shopper.addShopper.title</Tx> : <Tx>shopper.editShopper.title</Tx>}
                </DialogTitle>

                <DialogContent style={{paddingTop: 5}}>
                    <UploadProfileImageBox
                        image={imageToShow}
                        onImageSelect={onImageSelect}
                        removeImageHandle={removeImageHandle}
                    />

                    <Text
                        label="user.email"
                        value={email}
                        onChange={setEmail}
                        validators={['required', 'isEmail']}
                        errorMessages={['this field is required', 'email is not valid']}/>
                    <Text
                        label="user.name"
                        value={name}
                        onChange={setName}
                        validators={['required']}
                        errorMessages={['this field is required']}/>
                    <Text
                        label="user.phone"
                        value={phone}
                        onChange={setPhone}
                        type="tel"
                        validators={['matchRegexp:^\\+(?:[0-9]){1,3}(?:[ \\.\\-])?(?:\\([0-9]+\\))?[\\d \\.\\-]+$', 'required']}
                        errorMessages={['Phone number must start with +', 'this field is required']}
                    />

                    <Divider style={{marginBottom: 10}}/>

                    <Text
                        label="user.password"
                        value={password}
                        onChange={setPassword}
                        type="password"
                        validators={passwordValidation}
                        errorMessages={['this field is required']}/>
                    <Text
                        label="user.confirm_password"
                        value={confirmPassword}
                        onChange={setConfirmPassword}
                        type="password"
                        validators={passwordValidation}
                        errorMessages={['this field is required']}/>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type="submit">
                        <Tx>g.save</Tx>
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>
    );
};

export default ShopperAddDialog;